export default "__VITE_ASSET__3VR4tGR9__"